exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".playlist-wrap[data-v-e77b54fe] {\n  border-radius: 10px 10px 0 0;\n  overflow: hidden;\n}\n.message-wrap[data-v-e77b54fe] {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 400px;\n}\n.series-heading[data-v-e77b54fe] {\n  font-weight: 400;\n  font-size: 28px;\n  line-height: 34px;\n  letter-spacing: 0;\n  margin: 0;\n  color: #1f2126;\n}\n.grid-view[data-v-e77b54fe] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  margin-bottom: 16px;\n}\n.grid-view .sermon[data-v-e77b54fe] {\n  flex: none;\n}", ""]);

// exports
